import {format} from "date-fns-tz"

export default function getHourFromDate(date: Date) {
    return format(
        new Date(date),
        "HH:mm"
    );
}